import { Translatable } from '@fmnts/api/shared';
import { Adapter } from '@fmnts/core';
import { ApiModalAdapter } from '../adapter/modal.adapter';
import { CampaignFieldset, CampaignFieldsetAdapter } from './campaign-fieldset';
import { FormModal } from './form-modal';
import { FormNavigation, FormNavigationAdapter } from './form-navigation';
import { FormPage } from './form-page';

interface ICampaignPage {
  key: string;
  fieldsets: CampaignFieldset[];
  headerImage: Translatable<string>;
  label: Translatable<string>;
  navigation: FormNavigation[];
  modals: readonly FormModal[];
}
export class CampaignPage extends FormPage {
  headerImage: Translatable<string>;
  override fieldsets: CampaignFieldset[];

  constructor(dto: Readonly<ICampaignPage>) {
    super(dto);
    this.fieldsets = dto.fieldsets;
    this.headerImage = dto.headerImage;
  }
}

export class CampaignPageAdapter implements Adapter<CampaignPage> {
  constructor(
    private actionAdapter = new FormNavigationAdapter(),
    private modalAdapter = new ApiModalAdapter(),
    private fieldsetAdapter = new CampaignFieldsetAdapter(),
  ) {}

  adapt(item: Record<string, any>): CampaignPage {
    return new CampaignPage({
      key: item['key'],
      fieldsets: (item['fieldsets'] || []).map((fieldset) =>
        this.fieldsetAdapter.adapt(fieldset),
      ),
      headerImage: item['header_image'],
      label: item['label'],
      navigation: (item['navigation'] || []).map((nav) =>
        this.actionAdapter.adapt(nav),
      ),
      modals: (item['modals'] || []).map((modal) =>
        this.modalAdapter.adapt(modal),
      ),
    });
  }
}
